import { Link } from "react-router-dom";
import { Phone, Sparkles } from "lucide-react";

const MobileBottomBar = () => {
  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-primary/95 backdrop-blur-xl border-t border-accent/30 shadow-[0_-4px_20px_rgba(0,0,0,0.3)]">
      {/* Gradient accent line */}
      <div className="h-0.5 bg-gradient-to-r from-accent via-white/40 to-accent" />
      
      <div className="grid grid-cols-2 divide-x divide-white/10">
        {/* Call Button */}
        <a
          href="tel:+19898432600"
          className="flex items-center justify-center gap-2 py-3 min-h-[52px] bg-accent/15 text-accent font-semibold text-xs xs:text-sm hover:bg-accent/25 active:scale-[0.98] transition-all"
          aria-label="Call Dallas Valentine directly at (989) 843-2600"
        >
          <span className="relative flex h-2.5 w-2.5">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-accent opacity-75"></span>
            <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-accent"></span>
          </span>
          <Phone className="h-4 w-4 shrink-0" />
          <div className="flex flex-col items-start leading-tight">
            <span className="font-bold text-primary-foreground text-xs">Call Dallas</span>
            <span className="text-[11px] text-accent font-mono font-medium">(989) 843-2600</span>
          </div>
        </a>
        
        {/* Live Work Button */}
        <Link
          to="/live-websites"
          className="flex items-center justify-center gap-2 py-3 min-h-[52px] bg-primary text-primary-foreground font-semibold text-xs xs:text-sm hover:bg-white/10 active:scale-[0.98] transition-all"
        >
          <Sparkles className="h-4 w-4 text-accent shrink-0" />
          <div className="flex flex-col items-start leading-tight">
            <span className="font-bold text-xs">Live Work</span>
            <span className="text-[11px] text-primary-foreground/70">Verified Systems</span>
          </div>
        </Link>
      </div>
    </div>
  );
};

export default MobileBottomBar;
